import { VersionItem } from './Version.interface';

export function isVersionEqual(a: VersionItem, b: VersionItem) {
  return a.id === b.id && a.version === b.version;
}
